import React, { Component } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Backend from "./app/containers/Backend";
import Auth from "./app/containers/Auth/Auth";
import "./App.css";

class App extends Component {
  render() {
    return (
      <div>
        <Switch>
          <Route path="/login" component={Auth} />
          <Route path="/" component={Backend} />
        </Switch>
      </div>
    );
  }
}

export default App;
